// extracted by mini-css-extract-plugin
export default {"rouletteImage":"rouletteMap-module__rouletteImage__DbKxM","mobileRouletteImage":"rouletteMap-module__mobileRouletteImage__+2Ljd"};